export default "__VITE_ASSET__D941E5iL__"